import { Component, OnInit, ViewChild, Input, OnDestroy, Output, EventEmitter } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { Subscription, BehaviorSubject, combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GetFullName, deepfind, Guid, extractDomainFromEmail, transformEmailDomain, showMFADialog } from 'app/shared/utils/utils';
import { ContactsService } from 'app/profile/services/contacts.service';
import { SupplierContactPropertyValue, ActionFlags, SupplierEntityPropertyValues, Language, DataWithSupplierCode, OPERATION, PropertyValue, TabPermissions, Permission, Supplier, EmailDomainPropertyValue, EmailDomain, SupplierDocument } from 'app/profile/models/supplier.model';
import { UserDetails, SupplierContactMap } from 'app/profile/models/user.model';
import { PageEvent, TslDialog } from '@tesla/ng-tds';
import { MasterDataService } from 'app/profile/services/masterdata.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { GetSupplierProfileCurrentUser, GetPreventativeInProgress,GetSupplierContactListByCode, GetSupplierEntityListByCode, EditSupplierContact, DeleteSupplierContact, AddSupplierContact, GetTabPermissions, GetSupplierDocumentsListByCode, GetValidationTaskByCode, GetSupplierOtpRequestByUser, GetEmailDomains } from 'app/profile/store/actions/supplierstate.action';
import { SelectCurrentUser, SelectSupplierContactList, SelectSupplierEntityList, SelectContactRoles, SelectLanguages, SelectTabPermissions, SelectValidationTask, SelectUserPendingTaskList,SelectPreventativeInProgress } from 'app/profile/store/app.selector';
import { GetContactRoleList, GetLanguageList } from 'app/profile/store/app.actions';
import { TabHistoryComponent } from 'app/profile/components/tab-history/tab-history.component';
import { BaseComponent } from 'app/profile/components/base.component';
import { ValidationTask } from 'app/profile/models/people.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { LocalStorageService } from 'app/shared/services/index.service';
import { isNullOrUndefined } from 'util';
import { AppSettings } from '../../../../../app.settings';
import { DomainEditComponent } from 'app/common/domain/domain-edit.component';
import { FileUploadService } from 'app/common/services/fileUpload.service';
import { SupplierTaskDetail } from 'app/profile/models/suppliertasks.model';
import { AuthData } from '@tesla/ng-auth';
import { statusClass, statusDisplay } from 'app/shared/constants';


@Component({
  selector: 'contact-grid',
  templateUrl: './contact-grid.component.html',
  styleUrls: ['./contact-grid.component.scss']
})
export class ContactGridComponent extends BaseComponent implements OnInit, OnDestroy {
  SupplierContactList: SupplierContactPropertyValue[];
  skip = 0;
  pageSize = 10;
  subscription: Subscription;
  IsApprover = false;
  flags = new ActionFlags();
  entityMap: SupplierEntityPropertyValues[];
  languages: Language[];
  missingCriticalContacts: string[];
  criticalContactTypes: string[];
  public isBusy = false;
  public isPrimaryValidation = false;
  public isSecondaryContact = false;
  public validateContactsInfo = "If you do not validate the toggle to yes for each individual, the contact will be deactivated.";
  public canDelete = true;
  public newContact: SupplierEntityPropertyValues = null;
  public isSelectionChanged = false;
  userDetails: UserDetails = null;
  isPrimary: boolean;
  isProfileAdmin: boolean;
  sortColumn: string;
  sortOrderDesc?: boolean;
  tabPermissions: TabPermissions;
  primaryPendingForApproval: boolean = false;
  preventativeHold: boolean =false;
  hasDraftValidationTask: boolean = false;
  hasPendingValidationTask: boolean = false;
  isValidationTaskComplete = false;
  primaryEmail: string;
  validationTask: ValidationTask;
  userPendingTasks: SupplierTaskDetail[] = [];

  // Messages
  isContactValidationPendingTaskErrorMessage: string = "No edit functionality available as your organization's contacts have yet to be validated, you are not enrolled in Multi-Factor Authentication, critical data changes are pending review, or you have no user access to manage this data.";

  // Status Display Variables
  statusClass = statusClass;
  statusDisplay = statusDisplay;
  
  displayedColumns = [
    "name",
    "mobile",
    "phone",
    "jobTitle",
    "languageCode",
    "email",
    "financeLead",
    "remitTo",
    "isPrimaryAccount",
    "purpose",
    "supplierCodes",
    "action"
  ];
  totalRows = 0;
  popUpKey: string = "PCFPopUp";
  popUpValue: boolean = false;
  pageSizeOptions: number[] = [10, 25, 50, 100, 250];
  gridViewData: BehaviorSubject<Array<SupplierContactPropertyValue>> = null;
  currentPageSize = 25;
  @Output() changeSubmitted = new EventEmitter();
  @Input() supplierCode = "";
  @Input() isPendingApproval = false;
  @Input() set source(sourceRef: string) {
    if (sourceRef === 'primary-validation') {
      this.isPrimaryValidation = true;
      this.isSecondaryContact = false;
    } else if (sourceRef === 'manage-contact') {
      this.isPrimaryValidation = false;
      this.isSecondaryContact = true;
    }
  }

  constructor(
    private contactService: ContactsService,
    private masterDataService: MasterDataService,
    private fb: FormBuilder,
    private dialog: TslDialog,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    public matDialog: MatDialog,
    private store: Store<SupplierState>,
    private translate: I18nService,
    private authData: AuthData,
    private contactsService: ContactsService,
    private localstorage: LocalStorageService,
    private fileUploadService: FileUploadService,
    private config: AppSettings) {
    super();
    this.subscription = new Subscription();
    this.gridViewData = new BehaviorSubject([]);
  }

  ngAfterViewInit(): void {

  }

  get hasWriteAccess(): boolean {
    return this.userDetails
      && this.isValidationTaskComplete
      && this.tabPermissions
      && this.tabPermissions.contact === Permission.ReadWrite
      && (this.userPendingTasks == null || this.userPendingTasks.length == 0 || this.userPendingTasks?.filter(x => x.subTaskType == "MFAEnrollment")?.length == 0)
      && (this.isPCFUploaded || this.showMFADialog);
  }

  get hasWriteAccessForValidationTask(): boolean {
    return this.userDetails
      && this.validationTask?.statusId !== 3
      && this.tabPermissions
      && this.tabPermissions.contact === Permission.ReadWrite
      && this.isPCFUploaded;
  }

  get hasEditPermissions(): boolean {
    return this.tabPermissions && this.tabPermissions.contact === Permission.ReadWrite;
  }

  ngOnInit() {
    this.route.parent.params.subscribe(params => {
      if (!params["code"]) {
        return;
      }

      this.supplierCode = params["code"];
      this.store.dispatch(new GetSupplierProfileCurrentUser());
      this.store.pipe(select(SelectUserPendingTaskList)).subscribe(x => {
        if (x) {
          this.userPendingTasks = x;
        }
      });

      this.store.dispatch(new GetPreventativeInProgress(this.supplierCode,true));
      this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
        if (x) {
          this.preventativeHold = x;
        }
      });

      this.store.dispatch(new GetTabPermissions(this.supplierCode, true));

      const user = this.store.pipe(select(SelectCurrentUser)).subscribe(result => {
        if (result) {
          this.userDetails = result;
          this.showMFADialog = showMFADialog(this.authData, result);
          if (this.userDetails.supplierContact && this.userDetails.supplierContact.supplierMaps) {
            let supplierMap: SupplierContactMap = this.userDetails.supplierContact.supplierMaps.find(x => x.supplierCode == this.supplierCode) as SupplierContactMap;
            this.isPrimary = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "primary");
            this.isProfileAdmin = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "profile admin");
          }
          if (this.supplierCode) {
            const selectTabPermission = this.store.pipe(select(SelectTabPermissions)).subscribe(tabPermissions => {
              this.tabPermissions = tabPermissions;
              this.currentPageSize = this.pageSizeOptions[0];
              this.initLoad();
            });
            this.subscription.add(selectTabPermission);
          }
        }
      });
    });
  }

  openPCFDialog() {
    this.showMFANotificationDialog(this.supplierCode, this.SupplierContactList, this.dialog);
  }

  initLoad(isReload: boolean = false) {
    this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, isReload));
    this.store.dispatch(new GetSupplierEntityListByCode(this.supplierCode, isReload));
    this.store.dispatch(new GetValidationTaskByCode(this.supplierCode, isReload));

    this.store.dispatch(new GetContactRoleList());
    this.store.dispatch(new GetLanguageList());

    this.PrimaryContactDocument(this.store, this.router, this.supplierCode, false);

    var supplierSub = combineLatest(
      [this.store.pipe(select(SelectSupplierContactList)),
        this.store.pipe(select(SelectSupplierEntityList)),
        this.store.pipe(select(SelectValidationTask)),
        this.store.pipe(select(SelectContactRoles)),
        this.store.pipe(select(SelectLanguages))
      ]).subscribe(([supplierContactResult, supplierEntityResult, validationTask, contactRoles, supplierLanguages]) => {
        if (supplierContactResult && supplierEntityResult && validationTask && contactRoles && supplierLanguages) {

          this.validationTask = validationTask;
          this.hasDraftValidationTask = this.validationTask.statusId === 1;
          this.hasPendingValidationTask = this.validationTask.statusId === 2;
          this.isValidationTaskComplete = this.validationTask.statusId === 3;
          if (this.hasPendingValidationTask) {
            this.primaryEmail = this.validationTask.email;
          }

          var items = supplierContactResult;
          let primary = items.filter(x => x.types.newValue.filter(x => x == "Primary"));
          if (primary) {
            if (primary[0] && primary[0].operation && !isNullOrUndefined(primary[0].operation.newValue)) {
              this.primaryPendingForApproval = true;
            }
          }
          this.entityMap = supplierEntityResult;
          var contactTypeResult = contactRoles;
          this.languages = supplierLanguages;
          this.criticalContactTypes = contactTypeResult.filter(x => x.isCritical === true).map(y => y.id);
          this.SupplierContactList = new Array(...items);
          this.totalRows = this.SupplierContactList.length;
          this.loadMissingCriticalContact();
          this.loadGrid(this.currentPageSize, 0);
        }
      }, err => {
        console.error(`Service call error: GetSupplierContactListByCode or getEntityListByCode. Details: ` + err);
      });
    this.subscription.add(supplierSub);
  }

  pageChange(pageChange: PageEvent) {
    const { previousPageIndex, pageSize, pageIndex } = pageChange;
    this.currentPageSize = pageSize;

    if (previousPageIndex === pageIndex) {
      this.loadGrid(pageSize, 0);
    } else {
      const from = pageIndex * pageSize;
      const to = from + pageSize;
      this.loadGrid(pageSize, from);
    }
  }

  setValid(dataItem, e) {
    dataItem.IsValid = e.checked;
  }

  getFullName(contact, type) {
    return GetFullName(contact, type);
  }

  getLanguage(languageCode) {
    if (languageCode && this.languages) {
      let language = this.languages.find(x => x.id === languageCode)
      return language ? language.name : "";
    }
  }

  loadGrid(take: number, skip: number) {
    let contactList = this.SupplierContactList.slice(skip, skip + take);
    contactList.forEach(x => {
      x.canUpdateItem = this.canChangeItem(x);
      x.canDeleteItem = x.canUpdateItem;
    });
    this.gridViewData.next(contactList);
    this.contactService.supplierContactItems = this.SupplierContactList;
    this.contactService.supplierContactItems.forEach(x => {
      if (x.types != undefined && x.types.newValue.indexOf('Primary') > -1) {
        x.isValid = true;
      }
    });
  }

  openDialog(dataItem: SupplierContactPropertyValue): void {
    if(this.showMFADialog){
      this.showMFANotificationDialog(this.supplierCode, this.SupplierContactList, this.dialog);
      return;
    }
    var matDataItem: DataWithSupplierCode<SupplierContactPropertyValue> = {
      data: dataItem,
      suppliercode: this.supplierCode,
      currentUser: this.userDetails,
      isManageContact: this.isSecondaryContact
    };
    const dialogRef = this.matDialog.open(ContactFormComponent, {
      minWidth: '1100px',
      disableClose: true,
      autoFocus: true,
      data: JSON.parse(JSON.stringify(matDataItem))
    });

    dialogRef.afterClosed().subscribe((x: Supplier) => {
      if (x) {
        // if add to valid domain true then open domain popup
        if (x.Contacts && x.Contacts.filter(x => (x["Operation"] == "Create" || x["Operation"] == "Update") && x["addToValidDomain"] == "Yes")?.length > 0) {
          // open domain window
          var dataItem = new EmailDomainPropertyValue();
          let addToDomainContact = x.Contacts.find(x => x["addToValidDomain"] == "Yes");
          dataItem.domain.newValue = "@" + extractDomainFromEmail(addToDomainContact["email"]);
          dataItem.disableDomainEdit.newValue = true;
          const emaildialogRef = this.matDialog.open(DomainEditComponent, {
            minWidth: '1100px',
            data: {
              suppliercode: this.supplierCode,
              disableClose: true,
              autoFocus: true,
              data: dataItem
            }
          });
          emaildialogRef.afterClosed().subscribe(res => {
            if (res) {
              this.saveDomain(res, x);
            } else {
              // discard changes
              this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, true));
              this.store.dispatch(new GetEmailDomains(this.supplierCode, true));
              this.initLoad(true);
            }
          });
        } else {
          this.syncContact(x);
        }
      } else {
        this.initLoad(true);
      }
    });
  }

  canChangeItem(dataItem) {
    if (!this.userDetails || this.isPCFValidationInReview) {
      return false;
    }
    let allowChangeItem = false;

    if (this.hasWriteAccess && dataItem && (!(dataItem.stageID && dataItem.stageID.newValue) || (dataItem.isTouched && (dataItem.stageID && dataItem.stageID.newValue)))) {
      var keys = Object.keys(dataItem);
      allowChangeItem = keys.some(key => deepfind(dataItem, `${key}.permission`) == "ReadWrite");
    }


    if (this.userPendingTasks?.filter(x => x.subTaskType == "MFAEnrollment")?.length > 0) {
      allowChangeItem = false;
    }

    return allowChangeItem;
  }

  syncContact(supplierDetails: Supplier) {
    if (supplierDetails && supplierDetails.Domains && supplierDetails.Domains.length > 0) {
      this.contactsService.processContactAndDomainChange(this.supplierCode, supplierDetails.Contacts, supplierDetails.Documents, supplierDetails.Domains).subscribe(evtResult => {
        if (evtResult) {
          if (evtResult.messages && evtResult.messages.filter(x => x.status === 'Error').length === 0) {
            this.snackBar.open('Success!', null, {
              duration: 5000,
              verticalPosition: 'top',
              panelClass: ['blue-snackbar']
            });
          } else {
            console.log('Error occurred while posting contact change event.', evtResult.messages);
            this.ShowError('Error', 'Error occurred while changing contact');
          }
        }
        else {
          console.log('Error occurred while posting contact change event.', evtResult.messages);
          this.ShowError('Error', 'Error occurred while posting contact change');
        }
      }, err => {
        console.error(`Service call error: processContactChange service call could not be completed. Details: ` + err);
        this.ShowError("Error", JSON.parse(err.Message).error.message);
      },
        () => {
          // TO clear or temporary changes on grid when error occurs
          this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, true));
          this.store.dispatch(new GetEmailDomains(this.supplierCode, true));
          this.initLoad(true);
        });

    } else {
      this.contactsService.processContactChange(this.supplierCode, supplierDetails.Contacts, supplierDetails.Documents).subscribe(evtResult => {
        if (evtResult) {
          if (evtResult.messages && evtResult.messages.filter(x => x.status === 'Error').length === 0) {
            // Close the popup and reload contact
            // this.loadData(true);
            this.snackBar.open('Success!', null, {
              duration: 5000,
              verticalPosition: 'top',
              panelClass: ['blue-snackbar']
            });
          } else {
            console.log('Error occurred while posting contact change event.', evtResult.messages);
            this.ShowError('Error', 'Error occurred while changing contact');
          }
        }
        else {
          console.log('Error occurred while posting contact change event.', evtResult.messages);
          this.ShowError('Error', 'Error occurred while posting contact change');
        }
      }, err => {
        console.error(`Service call error: processContactChange service call could not be completed. Details: ` + err);
        this.ShowError("Error", JSON.parse(err.Message).error.message);
      },
        () => {
          // TO clear or temporary changes on grid when error occurs
          this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, true));
        });
    }
  }

  saveDomain(emailDomain: EmailDomain, supplierDetails: Supplier) {
    let emailDomainPropertyValue = new EmailDomainPropertyValue();
    emailDomainPropertyValue.domain.newValue = emailDomain.domain;
    emailDomainPropertyValue.operation.newValue = emailDomain.operation;
    if (emailDomain.id) {
      emailDomainPropertyValue.id.newValue = emailDomain.id;
    }
    emailDomainPropertyValue.website.newValue = emailDomain.website;
    emailDomainPropertyValue.reason.newValue = emailDomain.reason;
    emailDomainPropertyValue.comment.newValue = emailDomain.comment;
    emailDomainPropertyValue.additionalReason.newValue = emailDomain.additionalReason;

    if (emailDomain?.documentInfos?.length > 0) {
      let file = emailDomain.documentInfos[0].File as File;
      this.fileUploadService.uploadFileToServer([file], this.supplierCode).subscribe(doc => {
        if (doc) {
          const document = new SupplierDocument();
          document.Operation = OPERATION.CREATE;
          document.DocumentID = doc.documentID;
          document.DocumentType = 'CORR-ED';
          document.FileName = doc.fileName;
          document.DocumentVersion = doc.documentVersion;
          document.ReferenceSystem = 'DMS';
          emailDomainPropertyValue.documents.newValue = [document.DocumentID];
          this.processDomainChange(document, emailDomainPropertyValue, supplierDetails);
        }
      });
    } else {
      this.processDomainChange(null, emailDomainPropertyValue, supplierDetails);
    }
  }

  processDomainChange(document: SupplierDocument, emailDomain: EmailDomainPropertyValue, supplierDetails: Supplier) {
    const result = transformEmailDomain(emailDomain);
    supplierDetails.Domains = [];
    supplierDetails.Domains.push(result);
    if (supplierDetails.Documents && supplierDetails.Documents.length > 0) {
      supplierDetails.Documents.push(document);
    } else {
      supplierDetails.Documents = [];
    }

    this.syncContact(supplierDetails);
  }

  ShowError(title: string, message: string) {
    this.translate.getAsync(message).subscribe((x: string) => {
      this.snackBar.open(x, '', {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
    });
  }

  deleteItem(item: SupplierContactPropertyValue) {
    if(this.showMFADialog){
      this.showMFANotificationDialog(this.supplierCode, this.SupplierContactList, this.dialog);
      return;
    }
    if (this.entityMap.findIndex(x => deepfind(x.contactID, 'newValue') &&
      (deepfind(x.contactID, 'newValue') === deepfind(item.id, 'newValue') ||
        deepfind(x.contactID, 'newValue') === deepfind(item.stageID, 'newValue'))) > -1) {
      this.snackBar.open(this.translate.get(`You cannot delete a contact that is active and in use. Please email vendorchanges@tesla.com for making changes!`), null, {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
    } else if (item.types != null && item.types.newValue.find(x => x == "Primary" || x == "Remit To" || x == "Finance Lead")) {
      this.canDelete = false;
      this.snackBar.open(this.translate.get(`You can not delete a Remit To, Finance Lead or a Primary contact!`), null, {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
    } else {
      const dialogRef = this.dialog.confirm(this.translate.get('Confirm'), this.translate.get('Are you sure you want to delete contact?'));
      dialogRef.afterClosed().subscribe((x: boolean) => {
        if (x) {
          if (item.id) {
            item.operation.newValue = OPERATION.DELETE;
            this.store.dispatch(new EditSupplierContact({
              index: this.SupplierContactList.indexOf(item),
              data: item
            }));
          } else {
            this.store.dispatch(new DeleteSupplierContact(this.SupplierContactList.indexOf(item)));
          }
          this.changeSubmitted.emit(true);
        }
      });
    }
  }

  loadMissingCriticalContact() {
    if (this.SupplierContactList != undefined) {
      this.missingCriticalContacts = this.criticalContactTypes.filter(c =>
        !this.SupplierContactList.some(x => x.types.newValue.some(y => c === y))
      );
    }
  }

  showHistory() {
    const dialogRef = this.matDialog.open(TabHistoryComponent, {
      width: '90%',
      minWidth: '630px',
      maxHeight: '800px',
      data: { supplierCode: this.supplierCode, tabName: 'Contact' }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  isEmpty(value: string) {
    return value === null || value.length === 0;
  }

  navigateToValidationTask() {
    event.preventDefault();
    window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=ContactValidation`);
  }
}
